import type { MutableRefObject } from 'react';
import { useUserData } from '../../../../hooks/useUserData';
import useMapModalStore from '../../../../stores/useMapModalStore';
import useMapViewStore from '../../../../stores/useMapViewStore';
import type { HighlightManager } from '../../controller/HighlightManager';
import RealEstateModal from '../../../../ui/modals/RealEstateModal';
import { closeMapSelectionModal } from './closeMapSelectionModal';

interface RealEstateCatalogModalProps {
  highlightManagerRef: MutableRefObject<HighlightManager | null>;
}

/** House-catalog modal (`activeModal === 'realEstate'`). Open flags + plotId from store. */
export default function RealEstateCatalogModal({ highlightManagerRef }: RealEstateCatalogModalProps) {
  const { data: userData } = useUserData();
  const isRealEstateModalOpen = useMapModalStore((s) => s.activeModal === 'realEstate');
  const realEstateCatalogPlotId = useMapModalStore((s) => s.payload.realEstateCatalogPlotId);
  const isRealEstateModalOnboarding = useMapModalStore((s) => s.payload.realEstateOnboarding);
  const markersReady = useMapViewStore((s) => s.markersReady);
  const isPixiAppReady = useMapViewStore((s) => s.isPixiAppReady);

  return (
        <RealEstateModal
          isOpen={isRealEstateModalOpen}
          plotId={realEstateCatalogPlotId}
          onClose={closeMapSelectionModal}
          isOnboarding={isRealEstateModalOnboarding}
          onNavigateToPurchasedHouse={(mapObjectId) => {
            window.setTimeout(() => {
              highlightManagerRef.current!.runPurchaseAnim(mapObjectId, markersReady, isPixiAppReady, userData);
            }, 200);
          }}
        />
  );
}
